// function getCartItemsSectionIds() {
//     return Array.from(document.querySelectorAll('cart-items-component'))
//         .map((component) => component.dataset.sectionId)
//         .filter(Boolean)
//         .join(',');
// }

// function morphCartDrawerSections(sections) {
//     import('@theme/component-cart-items').then(({ morphCartItemsSection }) => {
//         document.querySelectorAll('cart-items-component').forEach((component) => {
//             var sectionId = component.dataset.sectionId;
//             if (!sectionId || !sections[sectionId]) return;

//             morphCartItemsSection(sectionId, sections[sectionId], component.dataset.drawer !== undefined);
//         });
//     });
// }

// function refreshCartDrawerHtml(sections) {
//     if (sections) {
//         morphCartDrawerSections(sections);
//         return;
//     }

//     var sectionIds = getCartItemsSectionIds();
//     if (!sectionIds) return;

//     $.ajax({
//         type: 'GET',
//         url: window.location.pathname,
//         data: {
//             sections: sectionIds
//         },
//         dataType: 'json',
//         success: function(response) {
//             morphCartDrawerSections(response);
//         },
//         error: function(error) {
//             console.log('Cart drawer refresh error:', error);
//         }
//     });
// }

// setInterval(() => {
//     refreshCartDrawerHtml();
//     // alert("working");
// }, 5000);







$(document).on('click', '.embroidery_field_select_single', function(){
    $(this).closest('.embroidery_field_select_box').find('.embroidery_field_select_single').removeClass('active');
    $(this).addClass('active');
    fontColorUpdate();
    embroideryFieldsHideShow();
    embroideryPostion();
});
function fontColorUpdate(){
    var fontColor = $('.select_embroidery_color_single.active').attr('color_code');
    var fontName = $('.select_embroidery_font_single.active').attr('title');
    // alert(fontName);
    $('.product-information .embroidery_postion_text .text_embroidery').css({
      fontFamily: `"${fontName}"`,
      color: `${fontColor}`
    });
}
$(document).on('input', '.personalization_text_input_box input', function(){
    var text_embroidery = $(this).val();
    var valLength = $(this).val().length;
    var charBalance = 10-valLength
    $(this).closest('.personalization_text_input_box').find('.pending_text').attr('val',charBalance).text(charBalance);
    $('.product-information .embroidery_postion_text .text_embroidery').text(text_embroidery);
    fontColorUpdate();
    if(text_embroidery == ''){
        $('.personalization_text_input_box').addClass('error');
    }else {
        $('.personalization_text_input_box').removeClass('error');
    }
});

function embroideryFieldsHideShow(){
    var vl = $('.embroidery_field_select_single_hide_show.active').attr('embvalue');
    // alert(vl);
    if(vl == 'EMBROIDERY'){
        $('.personalization_text_box').slideDown();
        $('.custom_cart_btn').removeClass('hide_cart_btn');
        $('.custom_cart_btn').next().addClass('hide_cart_btn');
        $('.emb_selection_an_option').val(vl);
    }else {
        $('.personalization_text_box').slideUp();
        $('.personalization_text_input_box').find('.pending_text').attr('val',10).text('10');
        $('.personalization_text_input_box input').val('');
        $('.product-information .embroidery_postion_text .text_embroidery').text('');
        $('.custom_cart_btn').addClass('hide_cart_btn');
        $('.custom_cart_btn').next().removeClass('hide_cart_btn');
        $('.emb_properties').val('');
        $('.emb_selection_an_option').val(vl);
    }
    
}

function embroideryPostion(){
     var postion = $('.embroidery_position.active').attr('posvalue');
    //  alert(postion);
     if(postion == 'CENTER'){
        $('.product-information .embroidery_postion_text').addClass('center');
     }else {
        $('.product-information .embroidery_postion_text').removeClass('center');
     }
}

embroideryFieldsHideShow();


// $(document).on('click', '.custom_cart_btn', function() {

//     var thisForm = $(this).closest('form');
    
//     var customAddBtn = $(this);
//     var embText = $('.personalization_text_input_box input').val()
//     if(embText == ''){
//        $('.personalization_text_input_box').addClass('error');
//     }else{
//      $(thisForm).addClass('stop_click');   
//     var variantId = $('.embroidery_cost_prd').val();

//     // create unique key (timestamp)
//     var uniqueKey = new Date().getTime();
    
//     var embColor = $('.select_embroidery_color_single.active').attr('title');
//     var embFont = $('.select_embroidery_font_single.active').attr('title');
//     var embPosition = $('.embroidery_position.active').attr('posvalue');


//     $('.input_unique_key').val(uniqueKey);
//     $('.emb_text').val(embText);
//     $('.emb_color').val(embColor);
//     $('.emb_font').val(embFont);
//     $('.emb_postion').val(embPosition);

//     $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: {
//             id: variantId,
//             quantity: 1,
//             properties: {
//                 "Embroidery_key": uniqueKey
//             }
//         },
//         dataType: 'json',
//         success: function(response) {
//             $('.custom_cart_btn').addClass('hide_cart_btn');
//             $('.custom_cart_btn').next().removeClass('hide_cart_btn');
//             $(customAddBtn).next().trigger('click');
//             console.log('Product added:', response);
            
//             setTimeout(() => {
//                 $('.custom_cart_btn').removeClass('hide_cart_btn');
//                 $('.custom_cart_btn').next().addClass('hide_cart_btn');
//                 $(thisForm).removeClass('stop_click');
//             }, 1000);
//         },
//         error: function(error) {
//             console.log('Error:', error);
//             $(thisForm).removeClass('stop_click');
//         }
//     });
//     } 
    
// });




$(document).on('click', '.custom_cart_btn', async function() {
    
    var thisForm = $(this).closest('form');
    var customAddBtn = $(this);
    var embText = $('.personalization_text_input_box input').val();
    if (embText == '') {
        $('.personalization_text_input_box').addClass('error');
    } else {
        // debugger;
        // alert(thisForm.length)
        $(thisForm).addClass('stop_click');
        // $('.custom_cart_btn .add-to-cart-text__content_loading').show();
        var variantId = $('.embroidery_cost_prd').val();
       // create unique key (timestamp)
        var uniqueKey = new Date().getTime();
        var embColor = $('.select_embroidery_color_single.active').attr('title');
        var embFont = $('.select_embroidery_font_single.active').attr('title');
        var embPosition = $('.embroidery_position.active').attr('posvalue');
        $('.input_unique_key').val(uniqueKey);
        $('.emb_text').val(embText);
        $('.emb_color').val(embColor);
        $('.emb_font').val(embFont);
        $('.emb_postion').val(embPosition);
        // WAIT until image upload completed
        var uploadedImageUrl = '';
        // try {
        //     uploadedImageUrl = await generateAndUploadImage();
        //     console.log(uploadedImageUrl);
        //     // alert(uploadedImageUrl);
        //     $('.emb_image').val(uploadedImageUrl);
        // } catch (error) {
        //     console.log('Upload Error:', error);
        //     $(thisForm).removeClass('stop_click');
        //     return;
        // }


        // ajax runs AFTER upload complete
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: variantId,
                quantity: 1,
                properties: {
                    "Embroidery_key": uniqueKey
                }
            },
            dataType: 'json',

            success: function(response) {

                $('.custom_cart_btn').addClass('hide_cart_btn');

                $('.custom_cart_btn').next().removeClass('hide_cart_btn');

                $(customAddBtn).next().trigger('click');

                // console.log('Product added:', response);

                setTimeout(() => {

                    $('.custom_cart_btn').removeClass('hide_cart_btn');

                    $('.custom_cart_btn').next().addClass('hide_cart_btn');

                    $(thisForm).removeClass('stop_click');

                }, 1000);

            },

            error: function(error) {

                console.log('Error:', error);

                $(thisForm).removeClass('stop_click');

            }
        });

    }

});



// cart start

function customCartRefresh() {
    var sectionId = $('.cart-items-component').attr('data-section-id');

        $.get('/?section_id=' + sectionId, function(response) {

         // Get updated drawer HTML
         var updatedHtml = $(response)
           .find('.cart-drawer__inner')
           .html();

           // Replace current drawer HTML
           $('.cart-drawer__inner').html(updatedHtml);

            });
}

function cartTotalItemCount(){
    $.getJSON('/cart.js', function(cart) {
        $('.cart-bubble__text-count').text(cart.item_count);
    });
}


function embProductCheck(){

    $('.cart-items__table-row_not_clickable .cart-items__property[embroidery_key]').each(function(){

        var embCostElement = $(this);

        var embCostProductKey = embCostElement.attr('embroidery_key');
        var embCostPrdQty = embCostElement.closest('.cart-items__table-row_not_clickable').find('.quantity-selector input').val();
        var embCostPrditemKey = embCostElement.closest('.cart-items__table-row_not_clickable').attr('data-key');

        var isMatched = false;

        $('.cart-items__table-row_main .cart-items__property[embroidery_key]').each(function(){

            var embMainProductKey = $(this).attr('embroidery_key');
            var embMainPrdQty = $(this).closest('.cart-items__table-row_main').find('.quantity-selector input').val();

            if(embMainProductKey == embCostProductKey){

                isMatched = true;

                // console.log("Matched:", embCostProductKey);

                if(embMainPrdQty != embCostPrdQty){

                    $.ajax({
                        type: 'POST',
                        url: '/cart/update.js',
                        data: {
                            updates: {
                                [embCostPrditemKey]: embMainPrdQty
                            }
                        },
                        dataType: 'json',
                        success: function(cart) {
                            // console.log('Cart Updated', cart);
                            customCartRefresh();
                            cartTotalItemCount()
                        },
                        error: function(err) {
                            console.log(err);
                        }
                    });
                }
            }

        });

        // if no matching main product found
        if(!isMatched){

            // console.log("No Match Found:", embCostProductKey);

            $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: {
                    updates: {
                        [embCostPrditemKey]: 0
                    }
                },
                dataType: 'json',
                success: function(cart) {
                    // console.log('Removed Item', cart);
                    customCartRefresh();
                    cartTotalItemCount();
                },
                error: function(err) {
                    console.log(err);
                }
            });

        }

    });

}
// setInterval(() => {
    embProductCheck();
// }, 2500);

$(document).on('click', '.cart-items__quantity', function(){
    $('header-actions').addClass('stop_click');
    setTimeout(() => {
        // alert("hello1");
        embProductCheck();
    },3000)
    setTimeout(() => {
        // alert("hello2");
        $('header-actions').removeClass('stop_click');
    },4000)
    
})


// cart end


// upload image function
function generateAndUploadImage() {

    return new Promise(function(resolve, reject) {

        var firstParent = $('.embroidery_postion_text').first().parent();

        html2canvas(firstParent[0], {
            useCORS: true,
            backgroundColor: null
        }).then(function(canvas) {

            canvas.toBlob(function(blob) {

                var formData = new FormData();

                formData.append('file', blob);

                formData.append('upload_preset', 'ml_default');

                $.ajax({
                    url: 'https://api.cloudinary.com/v1_1/ddbrfoaxa/image/upload',
                    type: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,

                    success: function(response) {

                        console.log(response);

                        // uploaded image url
                        var uploadedUrl = response.secure_url;

                        // optional preview
                        $('.emb_image_get').attr('src', uploadedUrl);

                        // save url
                        $('.uploaded_image_url').val(uploadedUrl);

                        // return uploaded url
                        resolve(uploadedUrl);

                    },

                    error: function(error) {

                        console.log(error);

                        reject(error);

                    }
                });

            }, 'image/png');

        });

    });

}


// image upload

setInterval(() => {
    $('.cart-items__property[emboidery_image]').each(function(){
        var image = $(this).attr('emboidery_image');
        $(this).closest('.cart-items__table-row_main').find('.cart-items__media img').attr('src', image).attr('srcset', image);
    })
 }, 1000);
